<template>
  <div class="link-folder-template">
    <!--链接失效的提示界面-->
    <!-- <bs-invalid
      v-if="isInvalid"
      :data="data"
    /> -->
    <div
      class="isnormal"
    >
      <!-- <bs-auth
        v-show="isAuth"
        :data="data"
        @authToken="authToken"
      /> -->
      <!-- 外链文件夹 -->
      <div
        class="link-box"
      >
        <!-- 容器整体的部局 bs-structure组件的prop请仔细哦-->
        <bs-structure
          :display-right="false"
          :box-margin-r="60"
          :box-margin-l="60"
          :box-right-w="324"
        >
          <!-- header -->
          <template slot="boxHeader">
            <bsHeader
              type="folder"
              :data="data"
            />
          </template>
          <!-- body -->
          <template
            v-if="!data.params"
            slot="boxBody"
          >
            <div
              :class=" [showFerryInfo ? 'ferry-ScrollBody' : 'normal-ScrollBody']"
            >
              <ferry-info
                v-if="showFerryInfo"
                v-model="childContent"
                :data="data"
                class="ferry-info"
              />
              <div
                class="link-box-body"
                :class="{ exchange: showFerryInfo }"
              >
                <!-- P.S. 这里放预览组件/文件列表组件/异常组件/验证码组件 -->
                <!--导航栏组建，占个位置谁做谁删除了，再写-->
                <div
                  ref="navWrapper"
                  class="nav-wrapper clearfix"
                >
                  <div
                    v-if="data.source === 'file'"
                  >
                    {{ getTitle }}
                  </div>
                  <crumb
                    v-if="isShowCrumb && data.source !== 'file'"
                    :curb-map="curbMap"
                    :file-list="linkFolder.fileList"
                    :path="linkFolder.path"
                    :crumb-width="crumbWidth"
                    :is-ferry="showFerryInfo"
                    @crumbClick="crumbClick"
                    @goBack="goBack"
                    @refreshCrumb="refreshCrumb"
                  />
                  <div
                    ref="linkHeaderBtn"
                    class="nav-btn clearfix"
                  />
                </div>
                <!--文件列表组件-->
                <link-folder
                  ref="linkfolder"
                  :file-list="linkFolder.fileList"
                  :is-loading="linkFolder.loading"
                  :is-ferry="showFerryInfo"
                  @scrollLoadMore="loadMore"
                  @doSort="doSort"
                  @itemClick="itemClick"
                  @operationAction="operationAction"
                />
                <!--外链下载-->
                <iframe
                  id="download-iframe"
                  src="javascript:false;"
                  width="0"
                  heigth="0"
                  border="none"
                  style="display:none"
                />
              </div>
            </div>
          </template>
          <template
            v-else
            slot="boxBody"
          >
            <not-exist
              :content="data.message"
            />
          </template>
        </bs-structure>
      </div>
      <!--dialog-->
      <co-dialog
        v-if="dialog.isShow"
        ref="dilogEl"
        v-model="dialog.isShow"
        :title="dialog.title"
        :show-footer="false"
      >
        <component
          :is="dialogComponent"
          :data="data"
          :selected-data="selectedData"
          :token="linkFolder.requestParam.token"
          @closeDialog="closeDialog"
          @refreshList="successBack"
        />
      </co-dialog>
      <!--上传组件-->
      <bs-base-upload
        ref="dragUpload"
        @after-upload="successBack"
      />
    </div>
    <pkg-preview
      v-if="isShowPreviewPkg"
      @closePreviewPkg="() => {isShowPreviewPkg = false}"
      :current-list="linkFolder.fileList"
      :cur-selected-data="curSelectedData"
      @showTips="showTips"
    />
    <bs-webtool ref="bswebtool" />
    <client-download
      :visible.sync="isDownloadClient"
    />
  </div>
</template>
<script>
import * as Util from 'js/util/util.js'
import Preview from 'js/preview/preview-controller.js'
import bsAuth from 'components/business/link/auth/index.vue' // 外链提取码页面
import _$ from 'js/api/getdata.js'
import Crumb from 'components/business/approve/crumb/crumb.vue'
import bsStructure from 'components/business/structure/index.vue'
import bsLinkRight from 'components/business/approve/linkright/index.vue'
import bsHeader from 'components/business/approve/header/index.vue'
import { getFileList } from 'components/business/approve/lfolder/components/index'
import { sendLogBuryingPointMethods } from 'js/download-service/service-download'
import bsQrcode from 'components/business/qrcode/index.vue'
import coButton from 'components/common/button/index.vue'
import bsUpload from 'components/business/approve/privateupload/upload.vue'
import bsBaseUpload from 'components/business/approve/upload/upload-base.vue'
import bsInvalid from 'components/business/approve/invalid/index.vue'
import { linkDownLoad } from 'js/api/download/linkDown'
import { bsFileDownLoad } from 'js/api/download/download'
import coDialog from 'components/common/dialog/index.vue'
import transferSave from 'components/business/approve/transfer/index.vue'
import dndUpload from 'js/api/upload/dnd-upload'
import bsButton from 'components/business/approve/lbutton/index.vue'
import { LINKFILE } from 'js/mixin/linkcommon'
import ferryInfo from 'components/business/ferryInfo/index.vue'
import bsWebtool from 'components/business/webtool/index.vue'
import notExist from 'components/business/empty/index.vue'
import clientDownload from 'components/common/clientDownload/clientDownload.vue'
import { EventBus } from 'js/util/event-bus'
import linkFolder from './components/index.vue'
import { downloadFile } from '@filez/js-2-native'
import pkgPreview from './pkg-preview/pkg-preview.vue'

export default {
  name: 'LFolder',
  components: {
    notExist,
    Crumb,
    bsStructure,
    bsLinkRight,
    bsHeader,
    linkFolder,
    bsQrcode,
    bsAuth,
    coButton,
    coDialog,
    transferSave,
    bsUpload,
    bsBaseUpload,
    bsInvalid,
    bsButton,
    ferryInfo,
    bsWebtool,
    pkgPreview,
    clientDownload,
  },
  /**
         * 主要混入的函数
         * sendRecent
         */
  mixins: [LINKFILE],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      pathType: '',
      dataRange: 'getMetadata',
      playload: {},
      isEnd: false, // 是否加载完数据
      isShowHeader: true,
      displayRightPanel: true, // 默认展开右侧栏
      childContent: [],
      // 外联文件请求对象所需要的参数
      linkFolder: {
        fileList: {
          content: [],
        }, // 外联文件数据信息
        offset: 0, // 默认从第0条开始请求数据
        searchSort: { // 默认排序请求规则
          name: 'mtime',
          sortStatus: 2, // 1升序，2降序
        },
        neid: this.data.neid,
        from: '',
        prefix_neid: '',
        limit: 20, // 每次加载的条目数,
        loading: false, // 请求数据的加载loading,
        path: '/', // 请求外联的级数
        path_type: 'share_in',
        page_button_count: 5,
        include_deleted: false,
        page_size: 20,
        page_num: 0,
        sort: 'desc',
        orderby: 'mtime',
        account_id: 1,
        requestParam: { // 请求列表数据的必备参数
          code: '',
          token: '',
        },
      },
      selectedData: [],
      // 面包屑导航对应map
      curbMap: [],
      crumbWidth: 0,
      eodTipH: 0,
      isAuth: false, // 是否要输入提取码,
      rightData: {},
      dialogComponent: '',
      dialog: {
        isShow: false,
        title: '',
      },
      authData: {}, // 存储有关验证的信息
      topBtnShow: { // 顶部按钮显示控制
        isFirstRequest: true,
        power: {
          showDown: false,
          showUpload: false,
          showSavebox: false,
        },
      },
      isInvalid: false, // 默认链接没有失效
      currentId: '', // 当前的neid
      // 上传数据里需要的数据、
      uploadData: {
        deliveryCode: '',
        token: '',
        neid: '',
        upload_url: '',
        curPath: '',
      },
      // 链接数据
      shareInfo: {
        isSecurity: false, // 安全外链
        isApprove: false, // 审批外链
        isTrial: false, // 体验用户
        isLogin: false, // 是否登录认证
        isProtected: false, // 是否加了提取码
      },
      isShowCrumb: false,
      isShowPreviewPkg: false,
      curSelectedData: {},
      isDownloadClient: false,
    }
  },
  computed: {
    showFerryInfo() {
      return this.$route.name === 'ferry' || this.data.isFerry
    },
    getTitle() {
      return this.$route.name === 'ferry' || this.data.isFerry ? this.$t('摆渡内容') : this.$t('{n}的申请', { n: this.data.apply_name })
    },
    rPanelIcon() {
      let icon
      if (this.displayRightPanel) {
        icon = '#retractRightcolumn'
      } else if (this.abnormalType === 'noAccess') {
        icon = '#disExpendRightcolumn'
      } else {
        icon = '#expendRightcolumn'
      }
      return icon
    },
    getSelectedData() {
      if (this.isAuth) {
        return []
      }
      return this.$refs.linkfolder.getSelectFile().data
    },
    isMac() {
      return Util.isMac()
    },
    /**
     * 是否是安全外链
     */
    isSecurity() {
      if (this.shareInfo.isSecurity) this.eodTipH = 44
      return this.shareInfo.isSecurity
    },
  },
  watch: {
    /**
             * 当前目录级别的id,组装uploadData
             */
    currentId(n) {
      this.uploadData.neid = n
      this.uploadData.upload_url = this.linkFolder.fileList.upload_url
    },
    'linkFolder.path': function (n) {
      this.uploadData.curPath = n
    },
  },
  created() {
    // 直接加载数据
    this.pathType = (this.$route.name === 'ferry' && this.data.fromType === '1') ? 'exchange_manage' : 'share_in'
    if (this.$route.name === 'ferry') {
      this.ferryInit()
    } else {
      this.init()
    }
    // 注册拖动文件上传的的方法
    dndUpload({ i18n: window.i18n }, (fileData) => {
      this.$refs.dragUpload.authUpload(fileData, this.uploadData)
    })
  },
  mounted() {
    // 添加回退历史监听事件
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.goBackByHistory, false)
    }
    EventBus.$on('downloadClientDialog', () => {
      this.isDownloadClient = true
    })
  },
  destroyed() {
    // 销毁事件
    if (window.history && window.history.pushState) {
      document.removeEventListener('popstate', this.goBackByHistory)
    }
    EventBus.$off('downloadClientDialog')
  },
  methods: {
    // 上传抛错
    showTips(msg) {
      window.$toast.simpleShow(msg, 'warn')
    },
    eodDownload() {
      document.getElementById('download-iframe').setAttribute('src', '/client/DeliveryTool/DeliveryTool.zip')
    },
    /*
             * 关闭eod header tip
             */
    closeHeaderTip() {
      this.eodTipH = 0
    },
    /** 控制右侧栏 */
    toggleRightColumn() {
      this.displayRightPanel = !this.displayRightPanel
    },
    /**
             *获取顶部文件是否显示
            */
    getTopBtnisShow(data) {
      this.topBtnShow.isFirstRequest = false
      const power = data.access_mode
      if (/download/.test(power)) {
        this.topBtnShow.power.showDown = true
        this.topBtnShow.power.showSavebox = true
      }
      if (/upload/.test(power)) this.topBtnShow.power.showUpload = true
    },
    /** 下载 */
    download() {
      if (this.linkFolder.fileList.content.length < 0) {
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
        return
      }
      const selectData = this.$refs.linkfolder.getSelectFile().data.map((value) => value.data)
      if (selectData.length <= 0) {
        this.$toast.simpleShow('请您先选择文件', 'warn')
      } else {
        // 下载数据
        linkDownLoad(this.shareInfo, this.$store.state.curFileInfo, selectData)
      }
    },
    /* 审批任务类别
    action_type: {
      1: 创建链接,
      2: 下载,
      3: 上传,
      4: 删除,
      5: 摆渡
    }
    审批任务状态
    status: {
      1: 待审批,
      2: 已同意,
      3: 未通过,
      4: 已失效,
      -1: 已过期,
      0: 未提交
    } */
    /**
             * 初始化
             * @param {Object} paramData为getmetadata的参数中的token
             */
    async init() {
      // 重新设置请求path的分层级别
      if (sessionStorage.getItem('ListPath') !== '' && sessionStorage.getItem('ListPath') != undefined) {
        // 没有面包屑暂时不存储的localStorage
        this.linkFolder.path = sessionStorage.getItem('ListPath')
        // 重新设置面包屑导航
        this.curbMap = JSON.parse(sessionStorage.getItem('crum'))
      }
      const { neid,nsid } = this.data
      this.playload = {
        neid,
        nsid,
        path_type: 'share_in',
        page_button_count: 5,
        include_deleted: false,
        page_size: 20,
        page_num: 0,
        offset: 0,
        sort: 'desc',
        orderby: 'mtime',
        account_id: 1,
      }
      let metaData = {}
      try {
        metaData = (await _$.getData('getMetadata', this.playload)).data
      } catch (error) {
        this.showTips(error.response.data.message)
      }
      const { prefix_neid: prefixNeid, from } = metaData
      this.linkFolder.from = from
      this.linkFolder.prefix_neid = prefixNeid
      if (((this.data.action_type === '2' || this.data.action_type === '4') && this.data.source === 'folder') && !this.data.isFerry) {
        this.linkFolder.neid = metaData.content[0].neid
      }
      if (this.data.source === 'file') {
        this.linkFolder.path = metaData.path
      }
      if (this.curbMap.length > 1) {
        this.linkFolder.neid = this.curbMap[this.curbMap.length - 1].neid
      }
      this.$store.commit('GET_CUR_FILE_INFO', metaData)
      // 当前目录级别id
      this.getLinkFileList()
    },
    async ferryInit() {
      if (sessionStorage.getItem('ListPath') !== '' && sessionStorage.getItem('ListPath') !== undefined) {
        // 没有面包屑暂时不存储的localStorage
        /* 解决重试为新任务路由跳转问题 */
        this.linkFolder.path = '/'
        this.curbMap = []
      }
      const neid = this.data.snapshotNeid
      const nsid = this.data.snapshotNsid
      // 管理控制台
      if (this.data.fromType === '1') {
        this.playload = {
          url: this.data.sendPath,
          target_path: this.data.sendPath || '',
          path_type: 'exchange_manage',
          user_op: 'list_exchange',
          neid,
          nsid: this.data.snapshotNsid,
          prefix_neid: this.data.prefix_neid || '',
          account_id: this.data.account_id || '',
          uid: this.data.uid,
          page_size: 20,
          page_num: 0,
          offset: 0,
          sort: 'desc',
          orderby: 'mtime',
          page_button_count: 5,
          include_deleted: false,
        }
        this.dataRange = 'getSnapShotMetadata'
      } else { // 个人摆渡空间
        this.playload = {
          nsid,
          neid,
          path_type: 'share_in',
          page_button_count: 5,
          include_deleted: false,
          page_size: 20,
          page_num: 0,
          offset: 0,
          sort: 'desc',
          orderby: 'mtime',
          account_id: 1,
        }
        this.dataRange = 'getMetadata'
      }
      this.linkFolder.loading = true
      let d = await _$.postData(this.dataRange, this.playload)
      d = d.data
      const { path } = d
      let nPath = '/'
      if (path.split('/').length > 2) {
        nPath = path.indexOf('/', 1) === '-1' ? '/' : path.substring(path.indexOf('/', 1), path.length)
      }
      // 存储面包屑导航对应关系
      this.crubPathMap(path, nPath, neid)
      const { prefix_neid: prefixNeid, from } = d
      this.linkFolder.from = from
      this.linkFolder.prefix_neid = prefixNeid
      if (this.data.source === 'file') {
        this.linkFolder.path = d.path
      }
      if (this.curbMap.length > 1) {
        this.linkFolder.neid = this.curbMap[this.curbMap.length - 1].neid
      }
      this.$store.commit('GET_CUR_FILE_INFO', d)
      // 当前目录级别id
      this.currentId = d.neid
      // 设置右侧数据信息
      if (Object.keys(this.rightData).length <= 0) {
        this.rightData = d
        this.rightData.delivery_ad = (this.data.ext && this.data.ext.deliveryAd) === '1' || false
      }
      this.childContent = d.content
      getFileList(d, (resolve) => {
        if (resolve.content.length < this.linkFolder.limit) {
          this.isEnd = true
        } else {
          this.isEnd = false
        }
        if (this.topBtnShow.isFirstRequest) { this.getTopBtnisShow(d) }
        if (this.$refs.linkfolder) this.$refs.linkfolder.clearSelect()
        // 切换页面时滚动条自动滚动到顶部
        if (document.getElementById('virtual-scroll-wrapper') != null && this.linkFolder.fileList.content.length > 0) {
          document.getElementById('virtual-scroll-wrapper').scrollTop = 0
        } else if (this.linkFolder.fileList.content.length > 0) {
          document.getElementById('scroll-wrapper').scrollTop = 0
        }
        // 重新设置加载文件数
        this.linkFolder.fileList = resolve
        // 重新设置offset
        this.linkFolder.offset = resolve.content.length
        // 查看filelist打印
        this.$nextTick(() => {
          this.crumbWidth = this.getCrumbWidth()
          this.isShowCrumb = true
          this.getNeids()
        })
      })
      this.linkFolder.loading = false
      // 设置当前的path,并保证下次的刷新为当前路径
      this.linkFolder.path = d.path
      sessionStorage.setItem('ListPath', this.linkFolder.path)
      // 存储返回history历史,兼容ie9没有pushState问题。
      if ((window.history && window.history.pushState)) {
        // 支持History API
        window.history.pushState({ path: this.linkFolder.path, neid }, null, '')
      }
      // 隐藏提取码界面
      this.isAuth = false
    },
    /**
             * 获取当前面包屑宽度
             */
    getCrumbWidth() {
      if (this.$refs.linkHeaderBtn && this.$refs.navWrapper) {
        let btnMarginLeft = 0
        let navPaddingLeft = 0
        let navPaddingRight = 0
        if (window.getComputedStyle) {
          btnMarginLeft = +window.getComputedStyle(this.$refs.linkHeaderBtn)['margin-left'].replace('px', '')
          navPaddingLeft = +window.getComputedStyle(this.$refs.navWrapper)['padding-left'].replace('px', '')
          navPaddingRight = +window.getComputedStyle(this.$refs.navWrapper)['padding-right'].replace('px', '')
        }
        const parentWidth = this.$refs.navWrapper.offsetWidth - navPaddingLeft - navPaddingRight
        const btnWidth = this.$refs.linkHeaderBtn.offsetWidth + btnMarginLeft
        return parentWidth - btnWidth
      }
    },
    /**
             * 窗口变化回调函数
             */
    refreshCrumb() {
      this.crumbWidth = this.getCrumbWidth()
    },
    /**
             * 滚动加载更多数据
             */
    loadMore() {
      // 请求数据
      if (this.isEnd) {
        return false
      }
      this.getLinkFileList(true, false)
    },
    /**
             * 排序加载数据
             */
    doSort(data) {
      // 重置排序规则
      this.linkFolder.searchSort = data
      // 重置下标为0
      this.linkFolder.offset = 0
      // 现在测试默认就直接加载
      this.getLinkFileList(false, false)
    },
    /**
             *列表点击事件
            */

    itemClick(data) {
      // 判断试文件还是文件夹
      if (data.isDir) {
        // 请求文件夹下的数据
        this.linkFolder.offset = 0 // 重置下标
        // 计算路径的path
        this.linkFolder.path = data.path
        this.linkFolder.neid = data.neid
        // 请求数据
        this.getLinkFileList()
      } else {
        const type = data.mime_type.split('/').pop()
        if (Util.canSupportOpenCompressFile(type)) {
          const { handlers } = this.$route.query
          if (handlers === '0') {
            return
          }
          this.curSelectedData = data
          this.isShowPreviewPkg = true
          return
        }
        if (sessionStorage.getItem('character') === 'applier') {
          return false
        }
        // 重新打开进入预览文件的界面
        if (!(this.$route.name === 'ferry' && sessionStorage.getItem('auth') === 'list')) {
          this.goPreviewPage(data)
        }
      }
    },
    // 判断文件的大小限制
    async checkFileLimit(data) {
      const vm = this
      const param = {
        neid: data.neid,
        nsid: data.nsid,
      }
      const privilegeState = Util.getPrivatePrivilege(data.access_mode) // access_mode 被修饰过，已经不是Number，是“preview_upload_download"
      // eslint-disable-next-line no-return-await
      return await _$.getData('previewFileLimit', param).then((res) => {
        const checkData = res.data
        if (data && !checkData.checkSizeResult) { // 已超限
          const limitSize = Util.formatBytes(checkData.previewSizeLimit)
          if (privilegeState && privilegeState.canDownload) { // 有下载权限
            vm.$confirm.show({
              value: true,
              isShow: true,
              onlyOne: false,
              title: '提示',
              sureBtn: (Util.isClient() ? '本地打开' : '下载'),
              isDescribe: true,
              marskVisible: true,
              describe: `<span style="font-size:14px;color:#637282;display: inline-block;margin-top:4px;margin-bottom: 10px;">${this.$t('为了提供稳定的预览体验，目前仅支持下载查看')}</span>`,
              content: `<span style="font-size:16px;color:#1B2733;">${this.$t('该文档大小超过{n}暂不支持在线预览', { n: limitSize })}</span>`,
              sure() {
                if (Util.isClient()) {
                  vm.operationAction({ name: 'webLocalEdit', selectData: data })
                } else {
                  vm.operationAction({ name: 'download', selectData: { data: [{ data }] } })
                }
                vm.$confirm.hide()
              },
            })
            return false
          }
          vm.$confirm.show({ // 无下载权限
            value: true,
            isShow: true,
            onlyOne: true,
            title: '提示',
            isDescribe: true,
            sureBtn: '知道了',
            describe: `<span style="font-size:14px;color:#637282;display: inline-block;margin-top:4px;margin-bottom: 10px;">${this.$t('为了提供稳定的预览体验，目前仅支持下载查看')}</span>
                                        <span>${this.$t('如果您没有下载权限，请联系文件授权者或者系统管理员')}</span>`,
            content: `<span style="font-size:16px;color:#1B2733;">${this.$t('该文档大小超过{n}暂不支持在线预览', { n: limitSize })}</span>`,
            sure() {
              vm.$confirm.hide()
            },
          })
          return false
        }
        return true
      }).catch((err) => {
        // 如果接口500，那预览就跳不过去了，所以当保存时，先让用户跳过去，预览页中也有拦截
        if (err.response && err.response.status.toString().indexOf('50') >= 0) {
          return true
        }
      })
    },
    /**
             * 进入外链预览界面
             */
    async goPreviewPage(data, openNew = true) {
      const defaultParam = {
        path_type: 'ent',
        sort: this.linkFolder.sort,
        orderby: this.linkFolder.orderby,
        limit: 50,
        include_deleted: false,
      }
      const {
        neid, nsid, path_type: pathType, from, prefix_neid: prefixNeid,
      } = data
      const searchParam = Object.assign(defaultParam, {
        neid, nsid, path_type: pathType, from: pathType.includes('share') ? from : undefined, prefix_neid: prefixNeid,
      })
      const limitPass = await this.checkFileLimit(data)
      if (limitPass) {
        new Preview({
          data,
          type: 'file_preview',
          fileList: this.linkFolder.fileList,
          searchParam,
          vm: this,
        })
      }
      // const limitPass = await this.checkFileLimit(data) // 检验大小限制是否pass
      // // 重新打开进入预览文件的界面,文件在边界范围内，文件支持预览，文件含有预览权限
      // if (/^preview/.test(data.access_mode) && limitPass && Util.suppportPreview(data.mime_type)) {
      //   const { href } = this.$router.resolve({
      //     name: 'linkfile',
      //     params: {
      //       neid: data.neid,
      //     },
      //     query: {
      //       other: JSON.stringify({
      //         neid: this.currentId,
      //         nsid: data.nsid,
      //         metadata_url: data.metadata_url,
      //         token: this.authData.token,
      //         password: this.authData.password,
      //         code: this.linkFolder.requestParam.code,
      //         path: data.path,
      //         // offset: this.linkFolder.offset,
      //         orderby: this.linkFolder.searchSort.name,
      //         sort: this.linkFolder.searchSort.sortStatus == '1' ? 'asc' : 'desc',
      //         // limit: this.linkFolder.limit
      //       }),
      //     },
      //   })
      //   // 记日志
      //   sendLogBuryingPointMethods({
      //     category: 4,
      //     action: 404,
      //     pathType: this.$store.state.curFileInfo.path_type,
      //     entityStr1: data.neid,
      //   })
      //   openNew ? window.open(href, '_blank') : window.open(href)
      // }
    },
    // 根据path刷新列表
    refreshListData(data, index) {
      this.curbMap = this.curbMap.slice(0, +index + 1)
      this.linkFolder.neid = data.neid
      this.resetNewList(data.path)
      this.getLinkFileList()
    },
    /**
             * 清空列表配置数据
             */
    resetNewList(path) {
      this.linkFolder.fileList.content = []
      this.linkFolder.path = path
      this.linkFolder.offset = 0
    },
    /**
             * 面包屑点击
             */
    crumbClick(value) {
      // 存储当前路径
      sessionStorage.setItem('crum', JSON.stringify(this.curbMap))
      const { data, index } = value
      if (index) {
        this.refreshListData(data, index)
      }
    },
    /**
             * 返回上一个操作
             */
    goBack() {
      history.back()
    },
    /**
             * 面包屑导航的对应关系
             */
    crubPathMap(path, rpath, neid) {
      const routerStack = JSON.parse(sessionStorage.getItem('routerStack') || '[]')
      if (!routerStack.some((item) => item.path === path)) {
        routerStack.push({ path, rpath, neid })
        sessionStorage.setItem('routerStack', JSON.stringify(routerStack))
      }
      this.curbMap = this.curbMap.filter((item) => item.path != path)
      this.curbMap.push({ path, rpath, neid })
      sessionStorage.setItem('crum', JSON.stringify(this.curbMap))
    },
    /**
             * 获取外链文件夹信息
             * @param isScrollLoad Boolean 是否滚动加载数据
             * @param saveHistory Boolean 默认存储history历史
             */
    getLinkFileList(isScrollLoad = false, saveHistory = true) {
      const {
        searchSort, offset, limit, path, prefix_neid, from, neid,
      } = this.linkFolder // 是否为根目录
      const user_op = (this.$route.name === 'ferry' && this.data.fromType === '1') ? 'list_exchange' : ''
      // 真实的请求路径
      let nPath = '/'
      if (path.split('/').length > 2) {
        nPath = path.indexOf('/', 1) === '-1' ? '/' : path.substring(path.indexOf('/', 1), path.length)
      }
      // 存储面包屑导航对应关系
      this.crubPathMap(path, nPath, neid)
      // 设置排序模式
      const sort = searchSort.sortStatus === 1 ? 'asc' : 'desc'
      // 请求地址
      const params = {
        neid,
        nsid: this.data.nsid,
        path_type: this.pathType,
        user_op,
        prefix_neid,
        from,
        page_button_count: 5,
        include_deleted: false,
        page_size: limit,
        page_num: Math.ceil(offset / limit),
        offset,
        sort,
        orderby: searchSort.name,
        account_id: 1,
        target_path: path
      }
      // 开启加载的loading
      this.linkFolder.loading = true
      // 请求数据
      _$.postData(this.dataRange, params).then((res) => {
        this.$store.commit('GET_CUR_FILE_INFO', res.data)
        // 当前目录级别id
        this.currentId = res.data.neid
        // 设置右侧数据信息
        if (Object.keys(this.rightData).length <= 0) {
          this.rightData = res.data
          this.rightData.delivery_ad = (this.data.ext && this.data.ext.deliveryAd) == '1' || false
        }
        this.childContent = res.data.content
        if (this.$route.name !== 'ferry' && !this.data.isFerry) {
          // 如果为根路径,则返回值就是content
          if (path === '/') {
            delete res.data.content
            res.data.content = [{ ...res.data }]
            res.data.path = '/'
          }
        }
        // 重新组合返回数据
        getFileList(res.data, (resolve) => {
          // 设置顶部按钮权限
          if (resolve.content.length < this.linkFolder.limit) {
            this.isEnd = true
          } else {
            this.isEnd = false
          }
          if (this.topBtnShow.isFirstRequest) { this.getTopBtnisShow(res.data) }
          // 判断是否滚动
          if (isScrollLoad) {
            this.linkFolder.fileList.content = this.linkFolder.fileList.content.concat(resolve.content)
            // 重新设置offset
            this.linkFolder.offset = this.linkFolder.offset + resolve.content.length
          } else {
            // 清空选中数据,确保改组件在被初始化的情况下
            if (this.$refs.linkfolder) this.$refs.linkfolder.clearSelect()
            // 切换页面时滚动条自动滚动到顶部
            if (document.getElementById('virtual-scroll-wrapper') != null && this.linkFolder.fileList.content.length > 0) {
              document.getElementById('virtual-scroll-wrapper').scrollTop = 0
            } else if (this.linkFolder.fileList.content.length > 0) {
              document.getElementById('scroll-wrapper').scrollTop = 0
            }
            // 重新设置加载文件数
            this.linkFolder.fileList = resolve
            // 重新设置offset
            this.linkFolder.offset = resolve.content.length
          }
          // 查看filelist打印
          this.$nextTick(() => {
            this.crumbWidth = this.getCrumbWidth()
            this.isShowCrumb = true
            this.getNeids()
          })
        })
        // 关闭loading
        this.linkFolder.loading = false
        // 设置当前的path,并保证下次的刷新为当前路径
        this.linkFolder.path = res.data.path
        sessionStorage.setItem('ListPath', this.linkFolder.path)
        // 存储返回history历史,兼容ie9没有pushState问题。
        if ((window.history && window.history.pushState) && saveHistory) {
          // 支持History API
          window.history.pushState({ path: this.linkFolder.path, neid }, null, '')
        }
        // 隐藏提取码界面
        this.isAuth = false
      }).catch((error) => {
        // 请求异常...
        if (error.response && (error.response.status === 403 || error.response.status === 404)) {
          // this.error400 = true; //显示错误页面，显示外链失效界面
          if (error.response.status === 403) {
            this.isAuth = true
            return
          }
          if (this.data.isFerry && error.response.status === 404) {
            this.linkFolder.loading = false
            this.showTips(error.response.data.message)
            return
          }
          // 跳转到链接失效界面
          this.data.abnormalType = 'invalidLose'
          this.isInvalid = true
        }
      })
    },
    /**
             * 返回历史操作
             */
    goBackByHistory(event) {
      if (event.state == null) {
        window.location.reload()
      } else {
        // 重置导航
        const routerStack = JSON.parse(sessionStorage.getItem('routerStack'))
        const crubList = []
        this.linkFolder.neid = event.state.neid
        for (let i = 0; i < routerStack.length; i++) {
          crubList.push(routerStack[i])
          if (routerStack[i].path === event.state.path) {
            break
          }
        }
        this.curbMap = crubList
        this.resetNewList(event.state.path)
        this.getLinkFileList(false, false)
      }
    },
    webLocalEdit(data) {
      this.$refs.bswebtool.init(data)
    },
    /**
             * 列表按钮的点击事件
             */
    operationAction({ name, operateType, selectData }) {
      let type = ''
      switch (name) {
        // eslint-disable-next-line no-case-declarations
        case 'download':
          // 处理外部文件数据
          const data = []
          selectData.data.forEach((item) => {
            data.push(item.data)
          })
          const storageUrl = this.$store.state.lenovoData.LenovoData.storage_url
          const downData = { ...data[0] }
          if (Util.isClient()) {
            const params = {}
            downData.access_mode = downData.accessMode
            downData.nsid = downData.nsid.toString()
            params.remotePaths = [downData]
            downloadFile(params)
          } else {
            bsFileDownLoad({ isDir: downData.isDir, content: [downData], storageUrl })
          }
          break
        case 'openDir':
          this.itemClick(selectData.data[0].data)
          break
        case 'preview':
          type = selectData.data[0].data.mime_type.split('/').pop()
          if (Util.canSupportOpenCompressFile(type)) {
            this.curSelectedData = selectData.data[0].data
            this.isShowPreviewPkg = true
            return
          }
          this.goPreviewPage(selectData.data['0'].data)
          break
        case 'webLocalEdit':
          this.webLocalEdit(selectData)
        default:
          break
      }
    },
    // 下载
    downloadFile(selectData) {
      const { neid, nsid, path } = selectData
      // 查询是否有审批认证后进行下载
      isExistPolicy({ neid, nsid, path }, 'download').then(() => {
        this.downNewRevFile()
      }).catch((error) => {
        if (error.data) {
          if (error.data.length === 0) {
            window.$toast.simpleShow(this.$t('该审批规则没有审批者，请联系管理员'), 'warn')
          } else {
            this.apporvalData = {
              approvalType: 'download',
              approvers: error.data,
              neids: [neid],
              nsid,
              path,
            }
            this.$nextTick(() => {
              this.$refs.bsapproval.show()
            })
          }
        }
      })
    },
    /**
     * 下载最新版本的文件
     */
    downNewRevFile() {
      // 将当前metadata数据版本设置为空，必须未新对象防止污染旧对象
      const downData = { ...this.fileData }
      downData.rev = ''
      const downFile = { isDir: false, content: [downData] }
      bsFileDownLoad(downFile)
    },
    /**
             * 获取选中数据的neid
             */
    getNeids() {
      // if (this.data.ext.islogin) {
      //   const neids = JSON.parse(sessionStorage.getItem('openSave'))
      //   if (neids) {
      //     this.$refs.linkfolder.setSelectFile(neids)
      //     this.$nextTick(() => {
      //       this.transferSave()
      //     })
      //   }
      // }
    },
    /**
             * 存储选中数据的neid
             */
    saveNeids() {
      let result = []
      if (!this.selectedData) result = []
      result = this.selectedData.map((v, i) => v.data.neid)
      sessionStorage.setItem('openSave', JSON.stringify(result))
    },
    /**
             * 关闭弹框
             */
    closeDialog() {
      this.dialog.isShow = false
    },
    /**
             * 上传成功后的回调事件
             */
    successBack() {
      // 重新刷新当前目录级列表，从0-50开始
      // 重置下标为0
      this.linkFolder.offset = 0
      // 现在测试默认就直接加载
      this.getLinkFileList(false, false)
    },
    /**
             * 恢复之前的转存弹框
             */
    recoverTransfer() {

    },
  },
}
</script>
<style lang="less">
.link-folder-template .isnormal .link-box .ferry-ScrollBody{
  height: 100%;
  overflow: auto;
}
.link-folder-template .isnormal .link-box .normal-ScrollBody{
  height: 100%;
}
.link-folder-template {
  .link-box {
    .box-body-left {
      display: flex;
      flex-direction: column;
      .link-box-body {
        flex: 1 1 auto;
      }
      .link-box-body.exchange {
        height: calc(100% - 64px);
        .filelist-header {
          padding-left: 10px;
        }
        .filelist-item .filelist-item-inner .filelist-item-inner-blocks {
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import '~less/link.less';

.link-header-tip{
  font-size: 14px;
  line-height: 20px;
  position: relative;
  .download-area{
    color: #005EFE;
  }
  .close-icon{
    width: 14px;
    height: 14px;
    vertical-align: middle;
    position: absolute;
    top: 50%;
    right: 0px;
    margin-top: -7px;
    margin-right: 24.6px;
    cursor: pointer;
  }
}
.box-header{
  .right-pannel{
    min-width: 32px;
    padding: 0;
    margin-top: 9px;
    margin-right: 20px;
    float:right;
    .right-pannel-icon{
      width: 24px;
      height: 24px;
      vertical-align: -6px;
      display: inline-block;
    }
  }
  .eod-download{
    margin-top: 9px;
    float: right;
    .eod-download-icon{
      width: 20px;
      height: 20px;
      float: left;
      margin-top: 6px;
    }
  }
}


.ferry-info {
  margin: 24px 24px 24px 60px;
  flex: 0 0 auto;
}


.nav-wrapper{
  // // width: 910px;
  // height: 32px;
  // box-sizing: border-box;
  background-color: #fff;
  padding: 31px 24px 21px 60px;
  height: 32px;
}
.nav-btn{
  // margin-left: 24px;
  // float: right;
  position: absolute;
  right: 24px;
  top: 32px;
  margin-left: 24px;
  // float: right;
  height: 32px;
  box-sizing: border-box;
}

.link-box{
  width: 100%;
  height: 100%;
}

.link-right{
  #link-right{
    width: 100%;
  }
}

.link-folder-template{
  width: 100%;
  height: 100%;
}

.isnormal {
  width: 100%;
  height: 100%;
}
</style>
